// @ts-strict-ignore
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { appInject } from '../app-injector';
import { udpateFeasibilityRequestPending } from '../store/common/common.actions';

@Injectable()
export class FeasibilityRequestPendingInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const updateGloballyInStore = (feasibilityRequestPending: boolean): void => {
      appInject(Store).dispatch(udpateFeasibilityRequestPending({ feasibilityRequestPending }));
    };

    const isFeasitbilityRequest = (req: HttpRequest<unknown>): boolean => {
      const checkUrlForPattern = (url: string, regex: RegExp): boolean => regex.test(url);
      return checkUrlForPattern(req.url, /\/vehicles\/.*\/(?:add|remove)\//);
    };

    if (!isFeasitbilityRequest(request)) {
      return next.handle(request);
    }

    updateGloballyInStore(true);

    return next.handle(request).pipe(
      tap({
        next: (data: HttpResponse<unknown>) => {
          // no status for preflight request
          if (data.status) {
            updateGloballyInStore(false);
          }
        },
        error: () => {
          updateGloballyInStore(false);
        }
      })
    );
  }
}
